




















































import { Vue, Component } from "vue-property-decorator";
import { Action } from "vuex-class";
import { Routes } from "@/router/routes";

@Component
export default class Login extends Vue {
  @Action("login") login!: Function;
  error: string = "";
  form = {
    email: "",
    password: ""
  };

  mounted() {
    window.scrollTo(0, 0);
  }

  async submit() {
    try {
      const { email, password } = this.form;
      this.error = "";
      await this.login({ email, password });
      this.$router.replace({ name: Routes.DashBoard });
    } catch (err) {
      this.error = err.message;
    }
  }
}
